import api from '../helpers/api'

export const getCostColumns = () => api.get('/cost-columns')
export const saveCostColumn = (column: any) => api.post('/cost-columns', column)
export const editCostColumn = (column: any, id: number) => api.patch(`/cost-columns/${id}`, column)
export const deleteCostColumn = (id: number) => api.delete(`/cost-columns/${id}`)
